<span class="sis-chip" [class]="'sis-chip sis-chip--' + tone">
  <ng-content></ng-content>
</span>
